import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Booking from "@/pages/Booking";
import Admin from "@/pages/Admin";
import AdminResetPassword from "@/pages/AdminResetPassword";
import Privacy from "@/pages/Privacy";
import ChatBot from "@/components/ChatBot";

function App() {
  return (
    <div className="noise min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/reservar" element={<Booking />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/restablecer" element={<AdminResetPassword />} />
          <Route path="/privacidad" element={<Privacy />} />
        </Routes>
        <ChatBot />
      </BrowserRouter>
    </div>
  );
}

export default App;
